module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fa":{"Tracking Code":"کد پیگیری","How to deposit":"نحوه واریز","Payee":"اطلاعات حساب مقصد","The amount is also returned to your wallet":"همچنین مبلغ به کیف پول شما برگردانده شده است"}}')
  delete Component.options._Ctor
}
